import { effect } from '@preact/signals';
import { throttle } from 'es-toolkit';
import {
  currentDuration,
  currentEpisode,
  currentSeek,
  state,
} from '../global-state/audio-signals';
import { setEpisodeProgress } from '../global-state/user-data';

// Persist episode progess as it's played (define early so it can be flushed when loading new episode)
export const persistProgress = throttle(setEpisodeProgress, 500, {
  edges: ['leading', 'trailing'],
});

effect(() => {
  // Persist progress whenever episode, seek or duration change and episode is playing or seeking
  if (['playing', 'seeking'].includes(state.value)) {
    persistCurrentEpisodeProgress();
  }
});

// Also called whenever native app sends us a new seek value but we're not actively
// playing or seeking.
export function persistCurrentEpisodeProgress(updateTimestamp: number = Date.now()) {
  if (
    currentEpisode.value &&
    currentSeek.value &&
    (currentDuration.value || currentEpisode.value.duration)
  ) {
    persistProgress(
      currentEpisode.value,
      currentSeek.value,
      currentDuration.value || (currentEpisode.value.duration as number),
      updateTimestamp
    );
  }
}
